export default __webpack_public_path__ + "static/media/Guru-Parampara-35.009dbc32.png";